export default __webpack_public_path__ + "static/media/culprits_003.699c55c4.jpg";